import React, {useState} from 'react';
import { CommonModal } from '../../../AbstractElements';

/**
 * icon,name,onclickEvent,children
 */
const AddNewButton=({options,children}) =>{


    return (
        <>
          <button className='button-mega-menu outside'>
            <span className={`nav-link`} onClick={() => options.onclickEvent()}>
             {options.icon}
              <span>{options.name}</span>
            </span>
          </button>
        {children}
        </>
      );
}

export default AddNewButton
